/* W2M: small behaviours carried over from the live theme's custom.js (Flex 3).
   Each one only runs if its element is on the page. Built by step5_header_footer.py - edit the copy in _build-scripts.
   Not carried: old cart-note handlers (cart drawer replaced), product image mobile slider (Flex v7 does this natively),
   location drawer (now snippets/w2m-country.liquid). */
(function () {
  // Icon bar (sections/featured-icon-bar): autoplay carousel on mobile. The section's CSS turns it off at 768px+.
  function iconBars(root) {
    if (!window.Flickity) return;
    root.querySelectorAll('.icon-bars').forEach(function (el) {
      if (!Flickity.data(el)) new Flickity(el, { wrapAround: true, pageDots: false, initialIndex: 1, watchCSS: true, prevNextButtons: false, autoPlay: true });
    });
  }
  iconBars(document);
  document.addEventListener('shopify:section:load', function (e) { iconBars(e.target); });

  // (Product gallery dots removed - mobile gallery uses arrows, see w2m_v7_adjustments.css)

  // Search = products only, like live (Flex 3 had a "search only products" setting that v7 dropped). Adds type=product
  // to every search form (header overlay, mobile, search page, 404) so results show as the product grid.
  function productSearch() {
    document.querySelectorAll('form[action$="/search"]').forEach(function (f) {
      if (f.querySelector('input[name="type"]')) return;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'type'; i.value = 'product'; f.appendChild(i);
    });
  }
  productSearch();
  document.addEventListener('shopify:section:load', productSearch);

  document.addEventListener('click', function (e) {
    // Blog sidebar on mobile (sections/all_blog__main): the "Select" item opens/closes the list
    var init = e.target.closest('ul .init');
    if (init) {
      [].forEach.call(init.parentNode.children, function (li) {
        if (li !== init) li.style.display = getComputedStyle(li).display === 'none' ? 'list-item' : 'none';
      });
      return;
    }
    // Blog sidebar jump links: smooth scroll to the section
    var a = e.target.closest('.scroll-trigger a[href^="#"]');
    if (a) {
      var t = document.getElementById(decodeURIComponent(a.hash.slice(1)));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    }
  });
})();
